import { defineComponent as _defineComponent } from 'vue'
import { useSyncProp } from "../../composables/useSyncProp";

import QAgentLicensingSureLc from "@/components/utils/QAgentLicensingSureLc.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QAgentLicensing',
  props: {
    agent: null
  },
  emits: ["update:agent"],
  setup(__props: any, { emit }) {

const props = __props as {
	agent: any;
}





const agentSync = useSyncProp("agent", props, emit);

return { __sfc: true,props, emit, agentSync, QAgentLicensingSureLc }
}

})